/**
 * HASHES DE LOS FICHEROS DE FUENTE. Generado por tools/descargar-fuentes.mjs.
 *
 * `TextLayer.font.fileHash` guarda el hash de los BYTES con los que se
 * escribio el diseno: es lo que permite al compositor de produccion cargar el
 * fichero EXACTO anos despues y no una version distinta de la misma familia.
 */
export const HASHES_FUENTE: Record<string, Record<string, string>> = 
{
  "Inter": {
    "400": "sha256:3100e775e8616cd2611beecfa23a4263d7037586789b43f035236a2e6fbd4c62",
    "600": "sha256:3100e775e8616cd2611beecfa23a4263d7037586789b43f035236a2e6fbd4c62",
    "700": "sha256:3100e775e8616cd2611beecfa23a4263d7037586789b43f035236a2e6fbd4c62",
    "900": "sha256:3100e775e8616cd2611beecfa23a4263d7037586789b43f035236a2e6fbd4c62",
    "400i": "sha256:7291b5970da2237441273c03b424a504b70b18f09791473fab99687dcc314720",
    "600i": "sha256:7291b5970da2237441273c03b424a504b70b18f09791473fab99687dcc314720",
    "700i": "sha256:7291b5970da2237441273c03b424a504b70b18f09791473fab99687dcc314720",
    "900i": "sha256:7291b5970da2237441273c03b424a504b70b18f09791473fab99687dcc314720"
  },
  "Archivo": {
    "400": "sha256:8f704806dbedeaaeca334b11ec348bc3ac3a439d6431544b3afb54f534ee4967",
    "600": "sha256:8f704806dbedeaaeca334b11ec348bc3ac3a439d6431544b3afb54f534ee4967",
    "700": "sha256:8f704806dbedeaaeca334b11ec348bc3ac3a439d6431544b3afb54f534ee4967",
    "400i": "sha256:3d109f97a71d3d3d04d16e5c4b95be8f89146a55ebbed239b90f5a8c5d4f437a",
    "600i": "sha256:3d109f97a71d3d3d04d16e5c4b95be8f89146a55ebbed239b90f5a8c5d4f437a",
    "700i": "sha256:3d109f97a71d3d3d04d16e5c4b95be8f89146a55ebbed239b90f5a8c5d4f437a"
  },
  "Barlow": {
    "400": "sha256:b0a8ad37ac45f5fb22ced461576db72e44e295107aad7a9c8a7a4bad728fd03b",
    "600": "sha256:4b52ddd4836b592df0e4832b8286956883cdc651b015126bdd18f184b7f90cc3",
    "700": "sha256:2d797dd8b35dcb3413e1af9d7052b3f4f8c341a147cdcb01f4f06af80db53289",
    "400i": "sha256:7a306c56f630df002deeafbd521738e20795d765feea65030def2e80f9a3d62f",
    "600i": "sha256:8eccc3c886206556e8aa3d585003d5fc1b8071a4f1d63a04fcd58d4b9a492e92",
    "700i": "sha256:717f61f0f8cf46b1f2aa54283e91ae39b1a80c4769ccaa761c7fab813708bcff"
  },
  "Work Sans": {
    "400": "sha256:1dd49afc07fb2231b2ff686cbf007725fb2742271bb1f28ebd98f22a0d817343",
    "600": "sha256:1dd49afc07fb2231b2ff686cbf007725fb2742271bb1f28ebd98f22a0d817343",
    "700": "sha256:1dd49afc07fb2231b2ff686cbf007725fb2742271bb1f28ebd98f22a0d817343",
    "400i": "sha256:73468c2b5cc7c31456ee0c297ac87b2bfb7eb626bc79688dc3a320151fddcd2f",
    "600i": "sha256:73468c2b5cc7c31456ee0c297ac87b2bfb7eb626bc79688dc3a320151fddcd2f",
    "700i": "sha256:73468c2b5cc7c31456ee0c297ac87b2bfb7eb626bc79688dc3a320151fddcd2f"
  },
  "Oswald": {
    "400": "sha256:571f3457dab507b6f2ce5394d593ca015251b69fea81ab7a546bd2368e9fc3ed",
    "600": "sha256:571f3457dab507b6f2ce5394d593ca015251b69fea81ab7a546bd2368e9fc3ed",
    "700": "sha256:571f3457dab507b6f2ce5394d593ca015251b69fea81ab7a546bd2368e9fc3ed"
  },
  "Archivo Narrow": {
    "400": "sha256:e1097881272dd16039ffb9f8b5108332926750842d1fea1dd059d5396bb83ef2",
    "700": "sha256:e1097881272dd16039ffb9f8b5108332926750842d1fea1dd059d5396bb83ef2",
    "400i": "sha256:309571b55bd2a42c9fb1cf170f778ec2285a1c25716a6606e07a6a6389aeb1a4",
    "700i": "sha256:309571b55bd2a42c9fb1cf170f778ec2285a1c25716a6606e07a6a6389aeb1a4"
  },
  "Anton": {
    "400": "sha256:d0fa07ff63dd60cbc0e2f58e29c802dca2a5ae0276c999f59c6111ab7bbaec3b"
  },
  "Bebas Neue": {
    "400": "sha256:a7c90c89240c134f7fdd33d40c000ec90b79d675ea53e8cc5a6d423c073de412"
  },
  "Teko": {
    "400": "sha256:9f908ba2cfa6103dd08e4e59b6be48fafc790f55c7f718be712d3d13170a93fb",
    "600": "sha256:9f908ba2cfa6103dd08e4e59b6be48fafc790f55c7f718be712d3d13170a93fb",
    "700": "sha256:9f908ba2cfa6103dd08e4e59b6be48fafc790f55c7f718be712d3d13170a93fb"
  },
  "Bungee": {
    "400": "sha256:126eec706b7931682dbcf6c6efc274132c603f181fbf912678e6cfeb341e721b"
  },
  "Alfa Slab One": {
    "400": "sha256:48a110c7fda81f9921a6437e1a813dcea56df5a9f52f778c7b2f2151e36e4f2c"
  },
  "Titan One": {
    "400": "sha256:2f15f138af309ad659b62246999cccc2da21759ec8619d7e6ea759e8eb5a7a53"
  },
  "Bangers": {
    "400": "sha256:04f54ff42ea2b8fc50b4259c29c60b1e05e606b769c2fb541c98624346c9767c"
  },
  "Righteous": {
    "400": "sha256:17055c538efddf7a754a98bb7db3d15405316dfb4645c287421ed3e7f8769144"
  },
  "Playfair Display": {
    "400": "sha256:e0c764a8e9e1cce92163c55bac4b2ad6cd4cf8c696ce2289ab5c41565e65b7e2",
    "700": "sha256:e0c764a8e9e1cce92163c55bac4b2ad6cd4cf8c696ce2289ab5c41565e65b7e2",
    "900": "sha256:e0c764a8e9e1cce92163c55bac4b2ad6cd4cf8c696ce2289ab5c41565e65b7e2",
    "400i": "sha256:54af24bd0f911f0fd7399d5445ea2023ff501d6a69f2d728f1213072f977ab14",
    "700i": "sha256:54af24bd0f911f0fd7399d5445ea2023ff501d6a69f2d728f1213072f977ab14",
    "900i": "sha256:54af24bd0f911f0fd7399d5445ea2023ff501d6a69f2d728f1213072f977ab14"
  },
  "Abril Fatface": {
    "400": "sha256:edf7a1f3bc22e815ea426b102fa0493d20af482b242066e689a1263ebb2eeb68"
  },
  "Merriweather": {
    "400": "sha256:4fbe8dd9c23b1fd62a988bb8a69b8e692d810f773d9ef6ebca2ba2760c7b11ee",
    "700": "sha256:4fbe8dd9c23b1fd62a988bb8a69b8e692d810f773d9ef6ebca2ba2760c7b11ee",
    "900": "sha256:4fbe8dd9c23b1fd62a988bb8a69b8e692d810f773d9ef6ebca2ba2760c7b11ee",
    "400i": "sha256:caa1da88ecea68d5d4b79881792675c76e691f5141ae3fef85bd472920436053",
    "700i": "sha256:caa1da88ecea68d5d4b79881792675c76e691f5141ae3fef85bd472920436053",
    "900i": "sha256:caa1da88ecea68d5d4b79881792675c76e691f5141ae3fef85bd472920436053"
  },
  "Lora": {
    "400": "sha256:ddb8c66035104e233fc024669183aad3738b6daa16deee2ebb1241bd0f98ace1",
    "600": "sha256:ddb8c66035104e233fc024669183aad3738b6daa16deee2ebb1241bd0f98ace1",
    "700": "sha256:ddb8c66035104e233fc024669183aad3738b6daa16deee2ebb1241bd0f98ace1",
    "400i": "sha256:d824d807d4d832d12c87932d0b8ec1314dcfd502157a56dee6bb04cf8a3768ae",
    "600i": "sha256:d824d807d4d832d12c87932d0b8ec1314dcfd502157a56dee6bb04cf8a3768ae",
    "700i": "sha256:d824d807d4d832d12c87932d0b8ec1314dcfd502157a56dee6bb04cf8a3768ae"
  },
  "Bitter": {
    "400": "sha256:0efe0fbe6068354f3fad5a88bf31384051206652468eaa22232119354e7ea423",
    "600": "sha256:0efe0fbe6068354f3fad5a88bf31384051206652468eaa22232119354e7ea423",
    "700": "sha256:0efe0fbe6068354f3fad5a88bf31384051206652468eaa22232119354e7ea423",
    "400i": "sha256:46f805476f0bc693b935a7c7bd891736321fd48ae24c4887526d89d8de09cdd0",
    "600i": "sha256:46f805476f0bc693b935a7c7bd891736321fd48ae24c4887526d89d8de09cdd0",
    "700i": "sha256:46f805476f0bc693b935a7c7bd891736321fd48ae24c4887526d89d8de09cdd0"
  },
  "Lobster": {
    "400": "sha256:aed68c73817364906ff95d97be87246d106bd38d5e4397e4866ec831ee22f7ba"
  },
  "Pacifico": {
    "400": "sha256:99ec044ad9040a708e38f90ebd5984ca03fc46afeee26d5c77c4769c66ed89e2"
  },
  "Dancing Script": {
    "400": "sha256:51acdc0e009e1d84cca6b654c4218275d8ee33dd243f3df25f7412a824a78d99",
    "700": "sha256:51acdc0e009e1d84cca6b654c4218275d8ee33dd243f3df25f7412a824a78d99"
  },
  "Great Vibes": {
    "400": "sha256:c59dc73d29daf142ef2431f455d21464172374aa750d793a79d608735db2d856"
  },
  "Caveat": {
    "400": "sha256:891951df5e8b5b0f0bc760d31375405e795c666b5add70437de12d4a6482b33f",
    "700": "sha256:891951df5e8b5b0f0bc760d31375405e795c666b5add70437de12d4a6482b33f"
  },
  "Satisfy": {
    "400": "sha256:efed75fb59ebfac3006c1a815cef791a300d1a4f7e75b0bf0654fa4f6884098e"
  },
  "Baloo 2": {
    "400": "sha256:26fb4610d4bc976d2584ca15e66c11465dbc1f267a10dca668fcb3080dfe59c1",
    "600": "sha256:26fb4610d4bc976d2584ca15e66c11465dbc1f267a10dca668fcb3080dfe59c1",
    "800": "sha256:26fb4610d4bc976d2584ca15e66c11465dbc1f267a10dca668fcb3080dfe59c1"
  },
  "Fredoka": {
    "400": "sha256:99d6c78e043710d4f83ed90716779798b7b04eb690f73e0ad0e8f32d1f0e98c2",
    "600": "sha256:99d6c78e043710d4f83ed90716779798b7b04eb690f73e0ad0e8f32d1f0e98c2"
  },
  "Quicksand": {
    "400": "sha256:2add7d60b1cd2ab84c9967e23d5ec08eb3fc9635c46855b17d59404dec6b410e",
    "600": "sha256:2add7d60b1cd2ab84c9967e23d5ec08eb3fc9635c46855b17d59404dec6b410e",
    "700": "sha256:2add7d60b1cd2ab84c9967e23d5ec08eb3fc9635c46855b17d59404dec6b410e"
  },
  "Monoton": {
    "400": "sha256:54dd0ac1cf6c02e094ad114d3cc038baddc42e5d6ba1c0b74566cedaed765c4c"
  },
  "Rye": {
    "400": "sha256:00de26ff9e435fb8f9e3ad15877f9deb4b70f3945ae0abcf7f0ed278d593014b"
  }
};

/** Hash del fichero de esa familia/peso/estilo; cadena vacia si no lo tenemos. */
export function hashDeFuente(family: string, weight: number, italic: boolean): string {
  return HASHES_FUENTE[family]?.[`${weight}${italic ? 'i' : ''}`] ?? '';
}
